<script setup>
  import { Modal, Popover } from "bootstrap";
  import { defineAsyncComponent, onMounted, inject, shallowRef } from "vue";
  import popover from "@/directives/popover.js";
  const ModalPackageProcess = defineAsyncComponent(() => import("../../components/modals/pkgProcess.vue"));

  const axios = inject('axios');
  let toProcess = shallowRef(0);
  let pop = shallowRef({})
  let btn = shallowRef({})
  let mkVisible = shallowRef(false);
  let modal = shallowRef({});


  getStats()

  onMounted(() => {
    btn = document.querySelector('#floatingNotification');
  })

  async function getStats() {
    let { data } = await axios.get('/manager/get-stats')
    toProcess = data.stats

    if (toProcess > 0) {
      pop = new Popover(btn, {
        delay: 3000,
        html: true,
        content: `<div class="text-center lead">There ${toProcess > 1 ? 'are' : 'is'} <strong>${toProcess}</strong> package ${toProcess > 1 ? 's' : ''} to process.</div>`,
        placement: 'auto',
        trigger: 'manual'
      });

      pop.show()
    }
  }

  function fireProcessModal() {
    mkVisible.value = true;
    modal = new Modal(document.getElementById('package_process'), { keyboard: false, backdrop: 'static', focus: true })
    modal.show();
  }
</script>

<template>
  <ModalPackageProcess :visible="mkVisible" :modal="modal" />
  <a class="btn-scroll-top show" id="floatingNotification" style="z-index: 99999" @click.once="fireProcessModal">
    <i class="btn-scroll-top-icon ci-check"></i>
  </a>
</template>

<style scoped>

</style>